import React from "react";

export const numData = [
  {
    id: 0,
    heading: "2,00,000 Cr",
    description: (
      <p className="max-w-[146px] m-auto">Payouts processed every year</p>
    ),
  },
  {
    id: 1,
    heading: "> 50%",
    description: (
      <p className="max-w-[220px] m-auto">
        Market share in bulk disbursals in India
      </p>
    ),
  },
  {
    id: 2,
    heading: "1000+",
    description: (
      <p className="max-w-[150px] m-auto">Payouts processed every second</p>
    ),
  },
];

export const faqData = [
  {
    id: 0,
    q: (
      <div>
        <h2 className="text-[16px] font-body">What is escrow?</h2>
      </div>
    ),
    a: (
      <p>
        An escrow is an agreement between two or more parties over a financial
        transaction, where money is parked until the mentioned conditions in the
        agreement are met. A neutral third party called a Trustee [an escrow
        agent] makes sure conditions are met and disburses the money to the
        primary parties as per the agreement. This helps in ensuring trust and
        transparency between the parties.
      </p>
    ),
  },
  {
    id: 1,
    q: "How does escrow work?",
    a: (
      <ul className="list-decimal">
        <li>
          The escrow parties enter into a contractual agreement on the
          transaction and consent process. This will also be signed by the
          Trustee as a neutral party
        </li>
        <li>The Remitter/Buyer Deposits money in Escrow Account</li>
        <li>
          {" "}
          When Remitter/Buyer feels the terms in the agreement have been met, he
          gives consent to the Trustee to make disbursal to the
          Seller/Beneficiary{" "}
        </li>
        <li>
          If the conditions haven’t been met, the Remitter/Buyer can seek a
          refund of their money
        </li>
      </ul>
    ),
  },
  {
    id: 2,
    q: "Why should I use escrow?",
    a: (
      <p>
        Escrow protects the trust between both transacting parties. None of the
        parties has to worry about the money being misused as it is safely
        stored in a bank account until the termination of the Escrow Agreement.
      </p>
    ),
  },
  {
    id: 3,
    q:
      "What are the prerequisite documents required to get started with Escrow?",
    a: (
      <div>
        <p>
          To open an Escrow account, you need the following documents after your
          use case is validated:
        </p>
        <ul className="list-decimal">
          <li>Escrow agreement</li>
          <li>PAN & Bank account - KYC verification</li>
          <li>Company details</li>
        </ul>
      </div>
    ),
  },
  {
    id: 4,
    q: "Is there a limit to the amount I can put into escrow?",
    a: <p>As of now, there is no limit on the amount</p>,
  },
  {
    id: 5,
    q: "Are my funds safe in escrow?",
    a: (
      <p>
        Yes. Your funds are protected by the Trustee, a neutral third party as
        per the conditions of the agreement.
      </p>
    ),
  },
  {
    id: 6,
    q: "What happens if one party doesn't fulfil their part of the agreement?",
    a: (
      <p>
        If one party doesn’t fulfil their part of the agreement, the other party
        can request to get their money back, based on the agreement conditions
        and timelines.
      </p>
    ),
  },
  {
    id: 7,
    q: "Can I cancel a transaction once I've put my money into escrow?",
    a: (
      <p>
        Yes. You can cancel a transaction anytime before the expiry of the
        escrow agreement.
      </p>
    ),
  },
  {
    id: 8,
    q: "What use cases does ‘One Escrow’ by Cashfree Payments support?",
    a: (
      <p>
        One Escrow by Cashfree Payments is a plug-and-play escrow platform,
        supporting all your business use cases including and not limited to
        payouts, co-lending, supply chain financing,
        marketplaces/D2C/e-commerce, HRMS/Payroll platforms for salary payouts
        and many more. Get in touch with our escrow expert to validate your use
        case now!
      </p>
    ),
  },
];
